import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { Row, Col } from 'react-bootstrap'
import { Field, reduxForm } from 'redux-form'
import { FORM_CALLE_DE_CALADO } from '../../../../config/forms'
import { renderTextField } from '../../../Forms/fieldRenderers'
import { CerealDropdown } from '../../../Forms/SharedComponents/containers'
import { FormControlLabel, Switch } from '@material-ui/core'

function CamposCalleDeCalado (props) {
  const { capacidadInicial, habilitadoInicial, disabled, change: formChange } = props
  const [habilitado, setHabilitado] = useState(habilitadoInicial)

  const updateHabilitacion = () => {
    setHabilitado(!habilitado)
    formChange('habilitado', !habilitado)
  }

  useEffect(() => {
    setHabilitado(habilitadoInicial)
  }, [habilitadoInicial])

  return (
    <div style={{ width: '98%', margin: 'auto' }}>
      <Row>
        <Col md={5} style={{ marginTop: '12px' }}>
          <CerealDropdown disabled={disabled} />
          {disabled && <>No se puede modificar el cereal cuando la calle esta ocupada</>}
        </Col>
        <Col md={5} style={{ marginTop: '12px' }}>
          <Field
            name='capacidadCalle'
            type='number'
            label='Capacidad maxima'
            component={renderTextField}
            autoFocus={false}
            value={capacidadInicial}
            placeholder=''
          />
        </Col>
        <Col md={2} style={{ display: 'flex', justifyContent: 'center', marginTop: '3%' }}>
          <FormControlLabel
            control={
              <Switch
                color='primary'
                name='habilitado'
                onChange={updateHabilitacion}
                checked={!!habilitado}
              />
            }
            label='Habilitada'
          />
        </Col>
      </Row>
    </div>
  )
}

const mapStateToProps = (state) => ({

})

const withRedux = connect(mapStateToProps, null)

const withReduxForm = reduxForm({
  form: FORM_CALLE_DE_CALADO
})

export default withRedux(withReduxForm(CamposCalleDeCalado))
